import React, { useEffect, useState } from "react";
import ProfileHeader from "./ProfileHeader";
import ProfileTabs from "./ProfileTabs";
//import Profile from "./Profile";
import { useLocation } from "react-router-dom";
import General from "./General";
import Skills from "./Skills";
import Education from "./Education";
import References from "./References";
import Contacts from "./Contacts";
import Health from "./Health";
import Insurance from "./Insurance";
import Passport from "./Passport";
import Church from "./Church";
import Settings from "./Settings"
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import { useUser } from "../../Hooks/useUser";
import { useMediaQuery } from "@mui/material";

const ProfileContainer = () =>{

    const loc = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const user = useUser();
    const isMobile = useMediaQuery("(max-width:600px)");
    const [showBgReminder, setShowBgReminder] = useState(false);
    const [bgExpired, setBgExpired] = useState(false);

    useEffect(() => {
        const uid = user?.user?.UserID;
        if (!uid) {
            setShowBgReminder(false);
            return;
        }

        let cancelled = false;
        (async () => {
            try {
                const [userResp, bgSettingsResp] = await Promise.all([
                    axiosPrivate.get(`/api/users/${uid}`),
                    axiosPrivate.get('/api/background-check/settings').catch(() => ({ data: { enabled: false } })),
                ]);

                if (cancelled) return;
                const ud = userResp.data || {};
                const bgEnabled = Boolean(bgSettingsResp?.data?.enabled);
                const rawBgDate = ud.userSettings?.BP_BGCheckDate;
                const hasBgDate = Boolean(rawBgDate && String(rawBgDate).trim() !== '');

                let isBgExpired = false;
                if (hasBgDate) {
                    const d = new Date(rawBgDate);
                    if (!isNaN(d.getTime())) {
                        const expiry = new Date(d.getFullYear() + 3, 11, 31);
                        isBgExpired = new Date() > expiry;
                    }
                }

                setBgExpired(isBgExpired);
                setShowBgReminder(bgEnabled && (!hasBgDate || isBgExpired));
            } catch {
                if (!cancelled) setShowBgReminder(false);
            }
        })();

        return () => { cancelled = true; };
    }, [axiosPrivate, user?.user?.UserID]);
    //console.log(loc.hash);
    //const tabNum = loc.hash.slice(-1);
    //console.log('tabNumber:',tabNum);

    return(
        <div style={{ overflowX: 'hidden' }}>
            <ProfileHeader/>
            {showBgReminder && (
                <div
                    style={{
                        background: '#ffe1a5',
                        borderTop: '1px solid #f2c94c',
                        borderBottom: '1px solid #f2c94c',
                        padding: '10px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '12px',
                        flexWrap: 'wrap',
                    }}
                >
                    <div style={{ color: '#2a2410', fontSize: '14px', display: 'flex', alignItems: 'flex-start', gap: '8px', flex: '1 1 300px', minWidth: 0 }}>
                        <span
                            style={{
                                width: '18px',
                                height: '18px',
                                borderRadius: '50%',
                                background: '#fea900',
                                color: '#111',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                fontWeight: 900,
                                lineHeight: 1,
                                flexShrink: 0,
                                marginTop: '2px',
                            }}
                        >
                            !
                        </span>
                        <div style={{ minWidth: 0 }}>
                            <strong style={{ marginRight: 6 }}>
                                {bgExpired ? 'Background Check Expired' : 'Background Check Required'}
                            </strong>
                            <span>
                                {bgExpired
                                    ? '— Your background check has expired. Please renew to continue participating in opportunities.'
                                    : '— You may reserve opportunities, but cannot participate until your background check is complete'}
                            </span>
                        </div>
                    </div>
                    <a
                        href="https://ciaresearch.com/ec=NCBaptist"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            background: '#fea900',
                            color: '#1b1b1b',
                            borderRadius: '3px',
                            padding: '8px 12px',
                            fontWeight: 700,
                            fontSize: '12px',
                            textTransform: 'uppercase',
                            textDecoration: 'none',
                            letterSpacing: '0.4px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            margin: isMobile ? '0 auto' : 0,
                        }}
                    >
                        <span>Start Background Check</span>
                        <span
                            style={{
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                background: '#111',
                                color: '#fff8e1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                fontWeight: 700,
                                lineHeight: 1,
                            }}
                        >
                            ➜
                        </span>
                    </a>
                </div>
            )}
            <ProfileTabs/>
            {/* need to have conditional load for the pieces*/}
            { loc.hash === '' ? <General/> : ''}
            { loc.hash === '#general' ? <General UseFormContext={false}/> : ''}
            { loc.hash === '#skills' ? <Skills UseFormContext={false}/> : ''}
            { loc.hash === '#education' ? <Education UseFormContext={false}/> : ''}
            { loc.hash === '#references' ? <References UseFormContext={false}/> : ''}
            { loc.hash === '#contacts' ? <Contacts UseFormContext={false}/> : ''}
            { loc.hash === '#health' ? <Health UseFormContext={false}/> : ''}
            { loc.hash === '#insurance' ? <Insurance UseFormContext={false}/> : ''}
            { loc.hash === '#passport' ? <Passport UseFormContext={false}/> : ''}
            { loc.hash === '#church' ? <Church UseFormContext={false}/> : ''}
            { loc.hash === '#settings' ? <Settings UseFormContext={false}/> : ''}
        </div>
    )
}

export default ProfileContainer
